import React from 'react';
import { Card } from './ui/card';

const About = () => {
  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-image">
            <img 
              src="/about-image.png" 
              alt="Nick and JJ on set"
              className="rounded-image"
            />
          </div>
          <div className="about-content">
            <h2 className="section-title">About The Show</h2>
            <p className="about-text">
              <strong>The Nick and JJ Show</strong> is more than just entertainment — it's a platform created by Nicholas Buamah and Janae Madison to give youth a safe, positive, and empowering space to share their voices.
            </p>
            <p className="about-text">
              Filmed in front of a live teen studio audience, our show blends humor, honesty, and heart. We feature interviews with inspiring guests, exciting games, incredible performances, and real conversations about topics that matter — from pop culture and friendship to entrepreneurship and self-confidence.
            </p>
            <div className="quote-card">
              <blockquote>
                <p className="quote-text">
                  "The Nick and JJ Show isn't just a show — it's a movement. We're building a positive platform where kids feel seen, heard, and celebrated."
                </p>
                <footer className="quote-author">
                  — Danielle Hubbard, Executive Producer
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;